import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { formatHours, formatPosition } from '../common/formatter';
import { t } from '../common/LocalizationProvider';
import {cyberStyles} from "../cssShared/cyberTheme";
import AddressDisplay from "../shared/AddressDisplay";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    root: {
        padding: theme.spacing(1),
        fontSize: '0.7rem',
    },
    detailRow: {
        marginBottom: theme.spacing(0.5),
        display: 'flex',
    },
    title: {
        fontWeight: 'bold',
        minWidth: theme.spacing(10),
        marginRight: theme.spacing(1),
        fontSize: 'inherit',
    },
    deviceName: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        marginBottom: theme.spacing(1),
        textAlign: 'center',
    },
}));

AddressDisplay.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
};


const StartsStopsView = React.memo(({ position, status, deviceName, mapType }) => {
    const classes = useStyles();
    const { latitude, longitude } = useMemo(() => ({
        latitude: position?.latitude,
        longitude: position?.longitude,
    }), [position?.latitude, position?.longitude]);

    const currentDeviceName = position?.deviceName || deviceName || t('unknownDevice');

    const renderDetails = () => {
        if (position?.deviceName) {
            return (
                <>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('start')}</Typography>
                        <Typography variant="body2" className={classes.cancelButtonRemoveDialog}>{formatPosition(position.startTime, 'fixTime')}</Typography>
                    </Box>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('End')}</Typography>
                        <Typography variant="body2" className={classes.cancelButtonRemoveDialog}>{formatPosition(position.endTime, 'fixTime')}</Typography>
                    </Box>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('reportDuration')}</Typography>
                        <Typography variant="body2" className={classes.cancelButtonRemoveDialog}>{formatHours(position.duration)}</Typography>
                    </Box>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('positionAddress')}</Typography>
                        <AddressDisplay latitude={latitude} longitude={longitude} mapType={mapType}/>
                    </Box>
                </>
            );
        } else {
            return (
                <>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t(status || 'status')}</Typography> {/* Handle potential null status */}
                        <Typography variant="body2" className={classes.cancelButtonRemoveDialog}>{formatPosition(position?.deviceTime, 'fixTime')}</Typography>
                    </Box>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('sharedLocation')}</Typography>
                        <Typography variant="body2" className={classes.cancelButtonRemoveDialog}>
                            {`${formatPosition(latitude, 'latitude')} ${formatPosition(longitude, 'longitude')}`}
                        </Typography>
                    </Box>
                    <Box className={classes.detailRow}>
                        <Typography variant="body2" className={classes.titleStartStopView}>{t('positionAddress')}</Typography>
                        <AddressDisplay latitude={latitude} longitude={longitude} mapType={mapType} />
                    </Box>
                </>
            );
        }
    };

    if (!position) {
        return <div className={classes.root}>{t('noPositionData')}</div>;
    }

    return (
        <Box className={classes.root}>
            <Typography variant="h6" className={classes.nameDeviceStartStopView}>
                {currentDeviceName}
            </Typography>
            {renderDetails()}
        </Box>
    );
});

StartsStopsView.propTypes = {
    position: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        deviceName: PropTypes.string,
        startTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
        endTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
        deviceTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
        duration: PropTypes.number,
    }),
    status: PropTypes.string,
    deviceName: PropTypes.string,
};

StartsStopsView.defaultProps = {
    position: null,
    status: 'statusUnknown',
    deviceName: null,
};


export default StartsStopsView;